import { CurrentUserProfile } from '../../../../interfaces/User';
import { PaginationDots } from '../../../icons';

export const DocumentReview = ({
    userDetails
}: {
    userDetails: CurrentUserProfile;
}) => {
    return (
        <div className='flex flex-col pt-[100px] items-center'>
            <PaginationDots />
            <p className='font-semibold text-ebony pt-4'>
                Hi {userDetails?.firstName}, we’re reviewing your documents
            </p>
            <p className='text-sm text-midnightHaze max-w-[352px] text-center'>
                Please check back later for an update on your documents approval
                status.
            </p>
        </div>
    );
};
